import React, { useState, useRef, useEffect, useContext } from "react";
import { useHistory, NavLink } from "react-router-dom";
import { Container, Grid, Image, Form, Icon, Input } from 'semantic-ui-react'
import atar_logo from "../../assets/home/atar_logo.png";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { StarButton } from '../../components'
import { useSelector, useDispatch } from 'react-redux'
import { FormValidate } from '../../common'
import { celebForm } from '../../store/AuthRedux'
import close from '../../assets/home/close.svg'

const options = [
  { key: 1, text: 'Bollywood', value: 0 },
  { key: 2, text: 'Musicians', value: 1 },
  { key: 3, text: 'Cricketers', value: 2 },
  { key: 4, text: 'Sitcom stars', value: 3 },
]

const CelebrityScreen = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch()
  const history = useHistory();
  const pageActive = useRef(false);
  const celebs = useSelector((state) => state.auth.celebData)
  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  const [celeb, setCeleb] = useState({
    name: "",
    stagename: "",
    managername: "",
    managerphone: "",
    star: "",
    instagram: ""
  });

  const [icon, setIcon] = useState(true)


  const [errorceleb, setErrorceleb] = useState({
    name: null,
    stagename: null,
    managername: null,
    managerphone: null,
    star: null,
    instagram: null,
  });
  const inputChange = (key, val) => {
    setCeleb({ ...celeb, [key]: val })
    setErrorceleb({ ...errorceleb, [key]: null });
  }

  const submit = () => {
    let errorceleb = {}
    if (!celeb.name) {
      errorceleb['name'] = 'please enter your name'
    }
    if (celeb.name && !FormValidate.isName(celeb.name)) {
      errorceleb['name'] = 'Please enter a valid Name'
    }
    if (!celeb.stagename) {
      errorceleb['stagename'] = 'please enter your Stage Name'
    }
    if (celeb.stagename && !FormValidate.isName(celeb.stagename)) {
      errorceleb['stagename'] = 'Please enter a valid Stage Name'
    }
    if (!celeb.managername) {
      errorceleb['managername'] = 'please enter your manager name'
    }
    if (celeb.managername && !FormValidate.isName(celeb.managername)) {
      errorceleb['managername'] = 'Please enter a valid Manager Name'
    }
    if (!celeb.managerphone) {
      errorceleb['managerphone'] = 'please enter your Manager number'
    }
    if (celeb.managerphone && !FormValidate.isPhone(celeb.managerphone)) {
      errorceleb['managerphone'] = 'please enter valid 10 digit phone number'
    }
    if (!celeb.star) {
      errorceleb['star'] = 'please enter your Type of star you are?'
    }
    if (!celeb.instagram) {
      errorceleb['instagram'] = 'please enter your Instagram ID'
    }
    if (Object.keys(errorceleb).length > 0) {
      setErrorceleb(errorceleb)
      return
    }

    pageActive.current = true;
    dispatch(celebForm(celeb))
    setCeleb({
      name: "",
      stagename: "",
      managername: "",
      managerphone: "",
      star: "",
      instagram: "",
    })
  }


  useEffect(() => {
    if (celebs && pageActive.current) {
      history.push("/celebrity");
    }
  }, [celebs]);

  return (
    <div className="container-flud clearall">
      <NavLink
        to=""
        className='star-logo star-logo-celeb'
      >
        <Image className="logo_img" src={atar_logo} />
      </NavLink>

      <div className="celeb_bg">
        <div className="crus" onClick={() => history.push("/")}>
          <img src={close} />
        </div>
        <div className="celeb_sec">
          <h2>{t("celebrty2.titel")}<span>{t("celebrty2.celeb")}</span> </h2>
          <h3>{t("celebrty2.para")}</h3>
        </div>
        <h3 className="files">{t("celebrty2.basic")}</h3>


        <Form>

          <Form.Group widths={2}>
            <Form.Input className={(errorceleb.name ? 'errorceleb' : '')} value={celeb.name} onChange={(e) => inputChange('name', (e.target.value).trimStart())} placeholder='Celeb’s full name'
              error={errorceleb.name ? errorceleb.name : false}
            />
            <Form.Input className={(errorceleb.stagename ? 'errorceleb' : '')} value={celeb.stagename} onChange={(e) => inputChange('stagename', (e.target.value).trimStart())} placeholder='Stage name'
              error={errorceleb.stagename ? errorceleb.stagename : false} />
          </Form.Group>

          <Form.Group widths={2}>
            <Form.Input className={(errorceleb.managername ? 'errorceleb' : '')} value={celeb.managername} onChange={(e) => inputChange('managername', (e.target.value).trimStart())} placeholder='Manager name'
              error={errorceleb.managername ? errorceleb.managername : false} />
            <Form.Input className={(errorceleb.managerphone ? 'errorceleb' : '')} value={celeb.managerphone} onChange={(e) => inputChange('managerphone', (e.target.value).trimStart())} placeholder='Manager phone number'
              error={errorceleb.managerphone ? errorceleb.managerphone : false} />
          </Form.Group>

          <Form.Group widths={2}>
            <div className="celeb-drop_sec celebDropdown">
              <Form.Dropdown selection options={options} placeholder='Type of star you are?' trigger={celeb.star}
                onChange={(e, { value }) => inputChange('star', options[value].text)}
                icon="angle down"
                error={errorceleb.star ? errorceleb.star : false}
              />
            </div>
            <Form.Input className={(errorceleb.instagram ? 'errorceleb' : '')} value={celeb.instagram} onChange={(e) => inputChange('instagram', (e.target.value).trimStart())} placeholder='Instagram ID ( Optional )'
              error={errorceleb.instagram ? errorceleb.instagram : false} />
          </Form.Group>
        </Form>

        <div className="clearall textCenter destops">
          <StarButton background={'mainBg'} title={t("contestus.btn")} onClickAction={submit} />
        </div>
      </div>

      <div className="clearall textCenter mobiles">
        <StarButton background={'mainBg'} title={t("contestus.btn")} onClickAction={submit} />
      </div>
    </div>
  );
};

export default CelebrityScreen